<template>
  <div class="h-full flex" :gutter="10">
    <div class="h-full w-300px flex-shrink-0">
      <el-card class="h-full flex flex-col">
        <div class="mb-10px flex items-center text-14px">
          <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">{{
            '目录树'
          }}</span>
          <el-dropdown>
            <span class="el-dropdown-link">
              <i class="iconfont icon-line-moreVertical text-14px font-bold"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>展开全部</el-dropdown-item>
              <el-dropdown-item>收起全部</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="flex mb-20px">
          <el-input
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="treeKeyword"
            class="mr-10px flex-1"
            clearable
          ></el-input>
          <el-button
            type="primary"
            class="!h-36px"
            size="mini"
            @click="$refs.modelTreeTree.filter(treeKeyword)"
            >搜索</el-button
          >
          <!-- <el-button
            type="primary"
            size="mini"
            class="!h-36px"
            >新增</el-button
          > -->
        </div>
        <el-tree
          v-if="treeStandBy"
          ref="modelTreeTree"
          :default-expand-all="defaultExpandAll"
          :data="treeData"
          class="h-[calc(100%-84px)] overflow-auto"
          :props="{
            children: 'child',
            label: 'name',
          }"
          highlight-current
          node-key="id"
          :expand-on-click-node="true"
          :filter-node-method="filterTree"
          :default-expanded-keys="defaultExpandIds"
          :current-node-key="currentNodeKey"
          @node-click="handleNodeClick"
          v-loading="treeLoading"
        >
        </el-tree>
      </el-card>
    </div>
    <div class="h-full rightCol flex-auto ml-10px w-0px">
      <el-card class="h-full" v-loading="loading">
        <div class="flex mb-20px">
          <el-input
            size="small"
            clearable
            placeholder="采集任务名称"
            v-model="search.spiderName"
            style="width: 200px"
            class="!mr-10px"
          ></el-input>

          <el-select
            filterable
            size="small"
            v-model="search.spiderStatus"
            clearable
            placeholder="是否可用"
            class="!mr-10px"
          >
            <el-option
              placeholder="是否可用"
              v-for="item in options"
              :value="item.id"
              :label="item.label"
              :key="item.id"
            ></el-option>
          </el-select>
          <el-date-picker
            v-model="search.timeRange"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            start-placeholder="采集时间"
            end-placeholder="采集时间"
            range-separator="至"
            class="mr-10px"
          >
          </el-date-picker>
          <el-button type="primary" size="small" @click="searchList">搜索</el-button>
          <el-button type="primary" size="small" @click="reset">重置</el-button>
          <el-button
            type="danger"
            size="small"
            @click="deleteMember"
            >删除</el-button
          >
        </div>
        <el-table
          :data="tableData"
          width="100%"
          height="calc(100% - 115px)"
          border
          stripe
          @selection-change="SelectionChange"
        >
          <el-table-column type="selection" show-overflow-tooltip width="60"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            type="index"
            label="序号"
            width="60"
            align="center"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="采集任务名称"
            prop="spiderName"
            align="left"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="入库栏目"
            prop="columnName"
            align="left"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="是否可用"
            prop="spiderStatusName"
            align="left"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="描述"
            prop="description"
            align="left"
          ></el-table-column>
          <el-table-column label="是否显示" prop="isEnable" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isEnable"
                active-color="#0082ff"
                inactive-color="#ff4949"
                @change="switchChange($event, scope.row, false)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="采集时间"
            prop="spiderTime"
            align="left"
          ></el-table-column>
          <el-table-column label="操作" align="left" width="200px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="removeTableData(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div class="flex justify-end mt-20px">
          <el-pagination
            background
            @size-change="searchList"
            @current-change="findList"
            :current-page.sync="page.pageNo"
            layout="total, sizes, prev, pager, next, jumper"
            :page-size.sync="page.pageSize"
            :total="page.total"
            :page-sizes="[15, 30, 45, 60, 75, 90]"
            :pager-count="5"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { SpiderRecordApi, ColumApi } from '@wiz-api/workbench'
import dayjs from 'dayjs'

const spiderrecordapi = new SpiderRecordApi()
const columApi = new ColumApi()

export default {
  data() {
    return {
      keyword: '',
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      treeData: [],
      // 默认展开
      defaultExpandIds: [''],
      defaultExpandAll: false,
      currentNodeKey: '',

      search: {
        spiderName: null,
        spiderStatus: null,
        timeRange: [],
        columnId: null,
      },
      // 分类树显隐
      treeStandBy: true,
      tableData: [],
      treeLoading: false,
      currentTreeId: '',
      options: [
        {
          value: true,
          label: '是',
        },
        {
          value: false,
          label: '否',
        },
      ],
      value: '',
      treeKeyword: '',
      multipleSelect: [], // 列表勾选项
    }
  },
  created() {
    this.findList()
    this.getTreeData()
  },
  methods: {
    async switchChange(event, row, type) {
      const params = {
        isEnable: event,
        ids: [],
      }
      if (type) {
        params.ids = row
      } else {
        params.ids = [row.id]
      }
      // const [err] = await spiderConfigApi.changeStatus({ body: params })
      // if (!err) {
      //   this.$message.success('操作成功')
      //   this.getList()
      //   this.$refs.tableRef && this.$refs.tableRef.clearSelection()
      // }
    },
    // 自定义树过滤
    filterTree(value, data) {
      return data.name.includes(value)
    },
    reset() {
      this.search = {
        spiderName: null,
        spiderStatus: null,
        timeRange: [],
        columnId: this.search.columnId,
      }
    },
    handleNodeClick(node) {
      this.search.columnId = node.id
      this.searchList()
    },
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    async getTreeData() {
      const [err, res] = await columApi.tree(0)
      if (!err) {
        this.treeData = res
      }
    },
    async findList() {
      this.loading = true
      const [err, res] = await spiderrecordapi.page({
        body: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
          spiderName: this.search.spiderName,
          spiderStatus: this.search.spiderStatus,
          startTime: this.search.timeRange.length > 0 ? this.search.timeRange[0] : null,
          endTime: this.search.timeRange.length > 0 ? this.search.timeRange[1] : null,
          columnId: this.search.columnId,
        },
      })
      if (!err) {
        this.tableData = _.map(res.items, (item) => {
          item.spiderTime = item.spiderTime
            ? dayjs(item.spiderTime).format('YYYY-MM-DD HH:mm:ss')
            : ''
          item.spiderStatusName = item.spiderStatus === 1 ? '是' : '否'
          return item
        })
        this.page.total = res.totalCount
      }
      this.loading = false
    },
    removeTableData(data) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await spiderrecordapi.callDelete({
            id: data.id,
          })
          if (!err) {
            this.$message.success({
              showClose: true,
              message: '删除成功！',
            })
            if (this.tableData.length === 1 && this.pageNo !== 1) {
              this.pageNo -= 1
            }
            this.findList()
          }
        })
        .catch(() => {})
    },
    // 删除成员
    async deleteMember() {
      if (!this.multipleSelect.length) {
        this.$message.warning(this.$t('请先勾选要删除的数据'))
        return
      }
      this.$confirm('是否确认批量删除数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const param = []
          forEach(this.multipleSelect, (items) => {
            param.push(items.id)
          })
          const [err, res] = await spiderrecordapi.callDelete({
            body: param,
          })
          if (!err) {
            this.$message.success('删除数据成功')
            this.getUserList()
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    SelectionChange(value) {
      this.multipleSelect = value
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
